import { render, staticRenderFns } from "./linkURL.vue?vue&type=template&id=d47c73dc&scoped=true"
import script from "./linkURL.vue?vue&type=script&lang=js"
export * from "./linkURL.vue?vue&type=script&lang=js"
import style0 from "./linkURL.vue?vue&type=style&index=0&id=d47c73dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47c73dc",
  null
  
)

export default component.exports